//服务商接口
import axios from "./common.js";
import { testR, $encrypt,officialId } from "./common.js";
import store from "../store/index";
// axios.defaults.baseURL = "https://test-api.hakspay.cn/";
axios.defaults.headers.post["Content-Type"] = "application/json";
import { Message } from "element-ui";

/* var _data = {
  //TODO: 需要改成store的token
  //store.state.token.access_token
  access_token: localStorage.getItem("access_token"),
  token_type: localStorage.getItem("token_type"),
  service_no: localStorage.getItem("service_no")
}; */

//请求拦截器
/* axios.interceptors.request.use(async function(res) {
  try {
    // console.log("token-----------------",localStorage.getItem("access_token"));
    
    //TODO: 加请求头
    return res;
    //接口需要令牌的情况
  } catch (e) {
    console.log("出错", e);
    return res;
  } 
}); */

/** 获取所有权限
 * ServiceProvider/v2/permission/baseinfo/list
 * service_no @param {string} 服务商号
 *
 * */
export const getPermissList = async function() {
  return new Promise((resolve, reject) => {
    axios
      .post(`ServiceProvider/v2/permission/baseinfo/list`, {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        console.log("所有权先------------------------",res);
        if (testR(res)) {
          if (res.data.resp_data) {
            var t2 = [];
            var t4 = [];
            var t6 = [];
            // this.all_permission = res.data.resp_data;
            res.data.resp_data.forEach((item, index, arr) => {
              if (item.view_no.trim().length == 2) {
                t2.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length == 4) {
                t4.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length == 6) {
                t6.push({
                  id: item.permission_no.trim(),
                  view_no: item.view_no,
                  label: item.permission_name
                });
              }
            });
            // console.log(t2,t4,t6)

            for (let j = 0; j < t4.length; j++) {
              for (let i = 0; i < t6.length; i++) {
                if (t6[i].view_no.slice(0, 4) == t4[j].view_no.trim()) {
                  t4[j].childList.push(t6[i]);
                }
              }
            }
            for (let j = 0; j < t2.length; j++) {
              for (let i = 0; i < t4.length; i++) {
                if (t4[i].view_no.slice(0, 2) == t2[j].view_no.trim()) {
                  t2[j].childList.push(t4[i]);
                }
              }
            }
            // console.log(t2,t6)
            resolve({ t2, t6 });
          }
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**枚举用户组
 * ServiceProvider/v2/Usergroup/list
 * @returns
 */
export const getUsergroupList = function() {
  return new Promise((resolve, reject) => {
    axios
      .post("ServiceProvider/v2/Usergroup/list", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(err => {
        Message.error(err);
      });
  });
};

/**创建用户组
 * /ServiceProvider/v2/Usergroup/generate
 * @param {object} data {group_no:组号，group_name:组名}
 * @returns {Promise}
 */
export const createUserGroup = function(data) {
  return axios
    .post("ServiceProvider/v2/Usergroup/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no: data.group_no,
      group_name: data.group_name
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改用户组
 * /ServiceProvider/v2/Usergroup/Modify
 * @param {object} data
 * @returns {Promise}
 */
export const modifyUserGroup = function(data) {
  return axios
    .post("ServiceProvider/v2/Usergroup/Modify", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no: data.group_no,
      group_name: data.group_name,
      flag: data.flag
    })
    .catch(e => {
      Message.error(e);
    });
};

//给用户组授权
//https://test-api.hakspay.cn/v2/ePlatform/Service/ServiceProvider/UserGroupPermission/set

/**
 * 给用户组授权
 * ServiceProvider/v2/UserGroupPermission/set
 * @param {object}
 * @returns
 */
export const setUserGroupPermission = function({
  group_no,
  permission_no,
  description
}) {
  return axios
    .post("ServiceProvider/v2/UserGroupPermission/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no,
      permission_no,
      description
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组授权
 * ServiceProvider/v2/UserGroupPermission/delete
 * @param {*} param0
 * @returns
 */
export const deleteUserGroupPermission = function({ group_no, permission_no }) {
  return axios
    .post("ServiceProvider/v2/UserGroupPermission/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取用户组权限
 * ServiceProvider/v2/UserGroupPermission/list
 * @param {*} group_no
 * @returns
 */
export const getUserGroupPermission = function(group_no) {
  return axios
    .post("ServiceProvider/v2/UserGroupPermission/list", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组
 * ServiceProvider/v2/Usergroup/delete
 * @param {*} group_no
 * @returns
 */
export const deleteUsrGroup = function(group_no) {
  return axios
    .post("ServiceProvider/v2/Usergroup/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**给用户授权
 * ServiceProvider/v2/permission/account/set
 * @param {*} account_id
 * @param {*} permission_no
 * @param {string} account_type mobile_no account_id
 * @returns
 */
export const setAccountPermission = function(
  account_id,
  permission_no,
  account_type
) {
  return axios
    .post("ServiceProvider/v2/permission/account/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      account_id,
      account_type,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 删除用户授权
 * ServiceProvider/v2/permission/account/delete
 * @param {*} account_id
 * @param {*} permission_no
 * @returns
 */
export const delAccountPermission = function(account_id, permission_no) {
  console.log("删除的用户权限id：", permission_no);
  return axios
    .post("ServiceProvider/v2/permission/account/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      account_id,
      permission_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**服务商获取所有受过权的用户
 * ServiceProvider/v2/permission/account/ListAccount
 * @returns
 */
export const baseinfoListAccount = function() {
  return new Promise((resolve, reject) => {
    axios
      .post("ServiceProvider/v2/permission/account/ListAccount", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no")
      })
      .then(res => {
        if (testR(res)) {
          let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i]);
          }
          resolve(list);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

//TODO：
/** 查询指定用户的权限
 * ServiceProvider/v2/permission/account/query
 * @param {*} account_id
 * @returns
 */
export const getAccountPermission = function(account_id) {
  return new Promise((resolve, reject) => {
    axios
      .post("ServiceProvider/v2/permission/account/query", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        service_no: localStorage.getItem("service_no"),
        account_id
      })
      .then(res => {
        if (testR(res)) {
          /* let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i].permission_no);
          } */
          resolve(res);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**上传图片
 * serviceprovider/v2/common/UploadImg
 * @param {*} img
 * @returns
 */
export const serviceUploadImg = function(img) {
  return axios
    .post("serviceprovider/v2/common/UploadImg", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      img
    })
    .catch(e => {
      Message.error(e);
    });
};

/**创建店铺
 * ServiceProvider/v2/Merchant/Generate
 * @param {*} MerchantInfo
 * @returns
 */
export const merchantGenerate = function(MerchantInfo) {
  return axios
    .post("ServiceProvider/v2/Merchant/Generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      MerchantInfo
    })
    .catch(e => {
      Message.error(e);
    });
};

/**查询店铺信息
 * ServiceProvider/v2/Merchant/Query
 * @param {*} merchant_id
 * @returns
 */
export const serviceQueryMerchant = function(merchant_id) {
  return axios
    .post("ServiceProvider/v2/Merchant/Query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      merchant_id
    })
    .catch(e => {
      Message.error(e);
    });
};

/**查询所有的门店
 * ServiceProvider/v2/Merchant/list
 * @returns
 */
export const getServiceCreateMerchant = function() {
  return axios
    .post("ServiceProvider/v2/Merchant/list", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no")
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改店铺状态
 * /ServiceProvider/v2/Merchant/SetState
 * @param {*} merchant_id
 * @param {*} state
 * @returns
 */
export const merchantSetState = function(merchant_id, state) {
  return axios
    .post("ServiceProvider/v2/Merchant/SetState", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      merchant_id,
      state
    })
    .catch(e => {
      Message.error(e);
    });
};

/**创建子服务商
 * ServiceProvider/v2/subServiceProvider/generate
 * @param {*} service
 * @returns
 */
export const serviceGenerate = function(service) {
  return axios
    .post("ServiceProvider/v2/subServiceProvider/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      service
    })
    .catch(e => {
      Message.error(e);
    });
};

/** 所有子服务商
 * ServiceProvider/v2/subServiceProvider/list
 * @returns
 */
export const getserviceList = function() {
  return axios
    .post("/ServiceProvider/v2/subServiceProvider/list", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no")
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取子服务商详细信息
 * ServiceProvider/v2/subServiceProvider/query
 * @param {*} sub_service_no
 * @returns
 */
export const serviceQueryProvider = function(sub_service_no) {
  return axios
    .post("ServiceProvider/v2/subServiceProvider/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      sub_service_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 获取系统日志
 * @param {*} param0
 * @returns
 */
export const serviceLogQuery = function({ start_time, expire_time }) {
  return axios
    .post("ServiceProvider/v2/log/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      start_time,
      expire_time
    })
    .catch(e => {
      Message.error(e);
    });
};

/**
 * ServiceProvider/v2/log/delete
 */
export const serviceLogDelete = function(com_no) {
  return axios
    .post("ServiceProvider/v2/log/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      com_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**查询服务商自己的信息
 * ServiceProvider/v2/query
 * @returns {Promise}
 *
 */
export const serviceProviderQuery = function() {
  return axios
    .post("ServiceProvider/v2/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no")
    })
    .catch(e => {
      Message.error(e);
    });
};

//ServiceProvider/v2/modify
/**修改服务商资料
 *
 * @param {object} service 修改的内容（是一个数组）
 * @returns {Promise} 发起请求 返回一个 Promise 类型的值
 */
export const serviceProviderModify = function(service) {
  return axios
    .post("ServiceProvider/v2/modify", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      service
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改服务商密码
 * @param {string} password 新密码
 *
 * /ServiceProvider/v2/ChangePassword
 */
export const serviceChangePs = function(pass_word) {
  return axios
    .post("ServiceProvider/v2/ChangePassword", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      service_no: localStorage.getItem("service_no"),
      pass_word
    })
    .catch(e => {
      Message.error(e);
    });
};

/** 新建系统类别
 *  datas内容
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const classifyGenerate = function(datas) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    ...datas
  };
  return axios
    .post("merchant/v2/chain/classify/generate", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/** 修改系统类别
 *  datas内容
 *  "describe": "string",
 *  "classify_no": "string",
 *  "classify_name": "string",
 *  "parent_classify_no": "string"
 */
export const classifyModify = function(datas) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    ...datas
  };
  return axios
    .post("merchant/v2/chain/classify/modify", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * /merchant/v2/chain/classify/delete
 * 提供类别编号删除系统类
 * @param {string} classify_no 类别编号
 */
export const classifyDelete = function(classify_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no"),
    classify_no
  };
  return axios
    .post("merchant/v2/chain/classify/delete", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

//ServiceProvider/v2/Pay/WxPay/Settings

/**
 * 查询配置
 * @param {*} mch_no
 * @returns
 */
export const serviceWxPayquery = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return axios
    .post("ServiceProvider/v2/Pay/WxPay/query", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**获取所有在线店铺
 * /Merchant/v2/offlinestores/onLineMerchant
 * @returns Promise
 */
export const getOnLineMerchant = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return new Promise((resolve, reject) => {
    axios
      .post("Merchant/v2/offlinestores/onLineMerchant", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**
 *
 * /ServiceProvider/v2/Merchant/list
 * 获取管理的所有门店状态
 */
export const getOfflinestoresList = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    service_no: localStorage.getItem("service_no")
  };
  return new Promise((resolve, reject) => {
    axios
      .post("ServiceProvider/v2/Merchant/list", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};
